module.exports = __webpack_public_path__ + "img/arrow-point-right.cb4c3810.svg";